import { databaseService } from '../../services/databaseService';
import { APP_CONSTANTS } from '../../config/constants';

export async function snapshotDbCounts() {
  const T = APP_CONSTANTS.DATABASE.TABLES;
  const [
    checklists,
    valores,
    photos,
    signatures,
    marcacoes,
    bkg,
    pendImgs,
    pendDels,
  ] = await Promise.all([
    databaseService.listItems(T.GUINCHO_CHECKLISTS.NAME),
    databaseService.listItems(T.GUINCHO_VALORES_CHECKLIST.NAME),
    databaseService.listItems(T.CHECKLIST_PHOTOS.NAME),
    databaseService.listItems(T.CHECKLIST_SIGNATURES.NAME),
    databaseService.listItems(T.CHECKLIST_MARCACOES.NAME),
    databaseService.listItems(T.CHECKLIST_MARCACAO_BKG_IMAGES.NAME),
    databaseService.listItems('pending_images'),
    databaseService.listItems('pending_deletions'),
  ]);

  return {
    guincho_checklists: (checklists as any[]).length,
    guincho_valores_checklist: (valores as any[]).length,
    checklist_photos: (photos as any[]).length,
    checklist_signatures: (signatures as any[]).length,
    checklist_marcacoes: (marcacoes as any[]).length,
    checklist_marcacao_bkg_images: (bkg as any[]).length,
    pending_images: (pendImgs as any[]).length,
    pending_deletions: (pendDels as any[]).length,
  };
}


